"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconWrapper = exports.LabelWrapper = exports.StyledToggleButtonGroup = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var ToggleButtonGroup_1 = __importDefault(require("@mui/material/ToggleButtonGroup"));
var colors_1 = require("../ThemeProvider/colors");
exports.StyledToggleButtonGroup = (0, styled_1.default)(ToggleButtonGroup_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: ", ";\n  border: ", ";\n  height: 40px;\n  column-gap: ", ";\n  opacity: ", ";\n\n  .MuiToggleButton-root {\n    border-radius: ", ";\n    width: ", ";\n    height: ", ";\n    padding: ", ";\n    border: ", ";\n    column-gap: 8px;\n    transition: all 0.3s ease-in;\n    font-size: 14px;\n\n    svg {\n      vertical-align: middle;\n    }\n\n    &.Mui-disabled {\n      border-radius: ", ";\n      border-left: 0;\n    }\n\n    &.MuiButtonBase-root {\n      padding: ", ";\n      margin-left: 0;\n    }\n\n    &.Mui-selected {\n      background-color: ", ";\n      transition: '';\n      box-shadow: ", ";\n      &:hover {\n        background-color: ", ";\n      }\n      &:active {\n        background-color: ", ";\n      }\n    }\n\n    &:hover {\n      background-color: ", ";\n    }\n\n    &:active {\n      background-color: ", ";\n    }\n\n    &:focus-visible {\n      background-color: ", ";\n      outline: 3px solid #0060e0;\n      outline-offset: 3px;\n      z-index: 1;\n    }\n\n    &.MuiButtonBase-root:first-child {\n      border-top-left-radius: ", ";\n      border-bottom-left-radius: ", ";\n    }\n\n    &.MuiButtonBase-root:last-child {\n      border-top-right-radius: ", ";\n      border-bottom-right-radius: ", ";\n    }\n\n    &.MuiButtonBase-root:not(:first-child) {\n      border-left: ", ";\n    }\n\n    &.MuiButtonBase-root {\n      border: ", ";\n    }\n  }\n"], ["\n  background-color: ", ";\n  border-radius: ", ";\n  border: ", ";\n  height: 40px;\n  column-gap: ", ";\n  opacity: ", ";\n\n  .MuiToggleButton-root {\n    border-radius: ", ";\n    width: ", ";\n    height: ", ";\n    padding: ", ";\n    border: ", ";\n    column-gap: 8px;\n    transition: all 0.3s ease-in;\n    font-size: 14px;\n\n    svg {\n      vertical-align: middle;\n    }\n\n    &.Mui-disabled {\n      border-radius: ", ";\n      border-left: 0;\n    }\n\n    &.MuiButtonBase-root {\n      padding: ", ";\n      margin-left: 0;\n    }\n\n    &.Mui-selected {\n      background-color: ", ";\n      transition: '';\n      box-shadow: ", ";\n      &:hover {\n        background-color: ", ";\n      }\n      &:active {\n        background-color: ", ";\n      }\n    }\n\n    &:hover {\n      background-color: ", ";\n    }\n\n    &:active {\n      background-color: ", ";\n    }\n\n    &:focus-visible {\n      background-color: ", ";\n      outline: 3px solid #0060e0;\n      outline-offset: 3px;\n      z-index: 1;\n    }\n\n    &.MuiButtonBase-root:first-child {\n      border-top-left-radius: ", ";\n      border-bottom-left-radius: ", ";\n    }\n\n    &.MuiButtonBase-root:last-child {\n      border-top-right-radius: ", ";\n      border-bottom-right-radius: ", ";\n    }\n\n    &.MuiButtonBase-root:not(:first-child) {\n      border-left: ", ";\n    }\n\n    &.MuiButtonBase-root {\n      border: ", ";\n    }\n  }\n"])), function (_a) {
    var variant = _a.variant;
    return variant === 'secondary' ? '#fff' : colors_1.tannerGray[200];
}, function (_a) {
    var variant = _a.variant;
    return (variant === 'secondary' ? '' : '30px');
}, function (_a) {
    var variant = _a.variant;
    return variant === 'secondary'
        ? "1px solid ".concat(colors_1.tannerGray[300])
        : "4px solid ".concat(colors_1.tannerGray[200]);
}, function (_a) {
    var variant = _a.variant;
    return (variant === 'secondary' ? '0' : '4px');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? '0.4' : '1');
}, function (_a) {
    var iconOnly = _a.iconOnly, variant = _a.variant;
    if (variant === 'secondary') {
        return '';
    }
    return iconOnly ? '50%' : '30px';
}, function (_a) {
    var iconOnly = _a.iconOnly, variant = _a.variant;
    if (iconOnly) {
        return variant === 'secondary' ? '40px' : '32px';
    }
    return 'auto';
}, function (_a) {
    var iconOnly = _a.iconOnly, variant = _a.variant;
    if (iconOnly) {
        return variant === 'secondary' ? 'auto' : '32px';
    }
    return 'auto';
}, function (_a) {
    var iconOnly = _a.iconOnly, variant = _a.variant;
    if (variant === 'secondary') {
        return '';
    }
    return iconOnly ? '8px' : '';
}, function (_a) {
    var variant = _a.variant;
    return variant === 'secondary' ? 'none' : 'transparent';
}, function (_a) {
    var variant = _a.variant;
    return variant === 'secondary' ? '' : 'inherit';
}, function (_a) {
    var variant = _a.variant;
    return (variant === 'secondary' ? '8px' : '');
}, function (_a) {
    var variant = _a.variant;
    return variant === 'secondary' ? colors_1.tannerGray[200] : '#fff';
}, function (_a) {
    var variant = _a.variant;
    return variant === 'secondary' ? '' : '0px 1px 1px 0px rgba(0, 0, 0, 0.25)';
}, function (_a) {
    var variant = _a.variant;
    return variant === 'secondary' ? colors_1.tannerGray[200] : colors_1.tannerGray[300];
}, function (_a) {
    var variant = _a.variant;
    return variant === 'secondary' ? colors_1.tannerGray[300] : colors_1.tannerGray[400];
}, function (_a) {
    var variant = _a.variant;
    return variant === 'secondary' ? colors_1.tannerGray[200] : colors_1.tannerGray[300];
}, function (_a) {
    var variant = _a.variant;
    return variant === 'secondary' ? colors_1.tannerGray[300] : colors_1.tannerGray[400];
}, colors_1.tannerGray[300], function (_a) {
    var variant = _a.variant;
    return variant === 'secondary' ? '3px' : '';
}, function (_a) {
    var variant = _a.variant;
    return variant === 'secondary' ? '3px' : '';
}, function (_a) {
    var variant = _a.variant;
    return variant === 'secondary' ? '3px' : '';
}, function (_a) {
    var variant = _a.variant;
    return variant === 'secondary' ? '3px' : '';
}, function (_a) {
    var variant = _a.variant;
    return variant === 'secondary'
        ? "1px solid ".concat(colors_1.tannerGray[300], " !important")
        : '';
}, function (_a) {
    var variant = _a.variant;
    return (variant === 'secondary' ? '' : 'none');
});
exports.LabelWrapper = styled_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  text-transform: none;\n  font-weight: ", ";\n"], ["\n  color: ", ";\n  text-transform: none;\n  font-weight: ", ";\n"])), function (_a) {
    var isSelected = _a.isSelected, variant = _a.variant;
    if (variant === 'secondary') {
        return colors_1.tannerGray[800];
    }
    return isSelected ? '#0060E0' : '#525252';
}, function (_a) {
    var variant = _a.variant;
    return (variant === 'secondary' ? '700' : '500');
});
exports.IconWrapper = styled_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  margin: 0px;\n"], ["\n  color: ", ";\n  margin: 0px;\n"])), function (_a) {
    var isSelected = _a.isSelected, variant = _a.variant;
    if (variant === 'secondary') {
        return isSelected ? colors_1.tannerGray[700] : colors_1.tannerGray[800];
    }
    return isSelected ? '#0060E0' : '#525252';
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=styles.js.map